var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9734 25.0569C11.5601 25.0569 12.0627 24.557 12.0627 23.973C12.0627 23.3887 11.5599 22.8882 10.9734 22.8882H1.08859C0.502843 22.8882 0 23.3887 0 23.973C0.000235522 24.557 0.502843 25.0569 1.08859 25.0569H10.9734Z",
    fill: "url(#paint0_linear_486_2085)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9108 22.9717H37.1098C36.5233 22.9717 36.0205 23.4722 36.0205 24.0558C36.0205 24.6398 36.5231 25.1403 37.1098 25.1403H46.9108C47.4975 25.1403 48.0001 24.6398 48.0001 24.0558C48.0001 23.3887 47.4972 22.9717 46.9108 22.9717Z",
    fill: "url(#paint1_linear_486_2085)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2191 36.403C40.0414 35.4852 37.695 34.8184 35.3503 34.3178C35.6852 32.816 36.0199 31.3142 36.1878 29.6453L45.4022 29.6451C44.7326 32.0647 43.6433 34.3179 42.2191 36.403ZM12.062 29.6451C12.2299 31.2307 12.5646 32.816 12.8995 34.3178C10.4701 34.8184 8.20837 35.569 6.03074 36.403C4.60654 34.4006 3.51725 32.0647 2.9315 29.6453L12.062 29.6451ZM23.1192 29.6451V33.0658C20.3549 33.1496 17.5913 33.3993 14.994 33.9008C14.6593 32.5653 14.4075 31.1479 14.2396 29.6453L23.1192 29.6451ZM30.4915 41.1584C28.9835 43.7441 27.0564 45.3297 25.2137 45.7467V35.1512C27.8101 35.2354 30.3236 35.4855 32.753 35.9032C32.1673 37.8211 31.3288 39.6566 30.4915 41.1584ZM30.1566 44.9962C32.4181 42.6602 33.9261 39.3223 34.8475 36.2367C36.9415 36.7363 39.036 37.3216 40.9628 38.0721C38.1146 41.4091 34.3449 43.8286 30.1566 44.9962ZM18.0932 44.9962C13.9049 43.8286 10.1352 41.3247 7.28701 38.0721C9.21381 37.3216 11.3083 36.7366 13.4021 36.2367C14.4075 39.4068 15.9153 42.6602 18.0932 44.9962ZM23.1192 45.7465C21.1931 45.3295 19.3502 43.7441 17.8421 41.1584C16.9208 39.6566 16.1664 37.9049 15.5807 35.9032C18.0101 35.4852 20.6065 35.2354 23.119 35.1512L23.1192 45.7465ZM33.3397 33.8171C30.6592 33.3165 27.978 33.0658 25.2137 32.9823V29.5625H34.0931C33.9261 31.0643 33.6744 32.4825 33.3397 33.8171ZM46.7432 27.5608C44.4808 27.5608 4.27162 27.5608 1.59045 27.5608C0.920858 27.5608 0.418021 28.1441 0.585006 28.8112C2.84672 39.7401 12.5646 47.9999 24.2083 47.9999C35.9361 47.9999 45.5698 39.6566 47.8316 28.8112C47.8316 28.1441 47.3289 27.5608 46.7432 27.5608Z",
    fill: "url(#paint2_linear_486_2085)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03067 11.5421C8.2083 12.3769 10.4698 13.1275 12.8994 13.628C12.5645 15.0464 12.3137 16.5482 12.0619 18.0491H2.93143C3.60126 15.7132 4.60647 13.5445 6.03067 11.5421ZM36.1878 18.1327C36.0198 16.5482 35.6849 15.1292 35.3503 13.7108C37.6949 13.211 40.0414 12.4607 42.219 11.6256C43.5591 13.628 44.6484 15.797 45.318 18.2164L36.1878 18.1327ZM25.2137 18.1327V14.8791C27.978 14.7956 30.7423 14.5459 33.3396 14.0451C33.6743 15.2962 33.9261 16.7145 34.0931 18.0491H25.2137V18.1327ZM17.8423 6.78677C19.3503 4.2008 21.1931 2.69897 23.1189 2.19843L23.1192 12.7939C20.5225 12.7095 18.01 12.4607 15.5806 12.0436C16.1663 10.041 16.9207 8.28933 17.8423 6.78677ZM18.0931 2.94901C16.1663 4.9514 14.5752 7.95507 13.402 11.7091C11.3082 11.2086 9.29758 10.6246 7.28694 9.874C10.1351 6.53676 13.9046 4.11826 18.0931 2.94901ZM30.1565 2.94901C34.3448 4.11803 38.1146 6.6205 40.8789 9.874C38.9521 10.6243 36.9412 11.2086 34.7636 11.7091C33.6743 7.95507 32.0833 4.9514 30.1565 2.94901ZM30.4074 6.78677C31.329 8.28933 32.0833 10.1238 32.7529 12.1262C30.3235 12.5432 27.7269 12.794 25.2137 12.8768V2.19843C27.0566 2.61547 28.8993 4.2008 30.4074 6.78677ZM14.9101 14.1288C17.5912 14.6293 20.2717 14.8791 23.036 14.9629V18.2164H14.1564C14.4075 16.7146 14.6592 15.3799 14.9101 14.1288ZM1.59038 20.2188C4.10386 20.2188 44.2297 20.2188 46.6584 20.2188C47.3289 20.2188 47.8315 19.6347 47.6636 18.9677C45.4859 8.53843 36.4386 0.530257 25.2975 0.0297177C13.4861 -0.554558 3.01458 7.53712 0.584936 18.9677C0.418187 19.6345 0.920788 20.2188 1.59038 20.2188Z",
    fill: "url(#paint3_linear_486_2085)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.68 24.8908L17.7585 21.2202H16.5863L15.664 24.8908C14.4915 19.8847 14.9103 21.6363 14.8264 21.2202H13.4863L14.9103 26.6424H16.1666L17.005 23.0547L17.9254 26.6424H19.1826L20.5228 21.2202H19.4335C19.3506 22.0543 20.0202 19.3848 18.68 24.8908Z",
    fill: "url(#paint4_linear_486_2085)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8851 24.8908L24.9638 21.2202H23.7904L22.869 24.8908C21.6966 19.8847 22.1147 21.6363 22.0315 21.2202H20.6914L22.1147 26.6424H23.3719L24.2092 23.0547L25.1307 26.6424H26.3877L27.7281 21.2202H26.6388C26.5547 22.0543 27.2252 19.3848 25.8851 24.8908Z",
    fill: "url(#paint5_linear_486_2085)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0882 24.8908L32.1676 21.2202H30.9945L30.0731 24.8908C28.8997 19.8847 29.3185 21.6363 29.2353 21.2202H27.8945L29.3185 26.6424H30.5757L31.4132 23.0547L32.3346 26.6424H33.5909L34.931 21.2202H33.8426C33.7588 22.0543 34.4291 19.3848 33.0882 24.8908Z",
    fill: "url(#paint6_linear_486_2085)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_2085",
    x1: 6.03135,
    y1: 22.8882,
    x2: 6.03135,
    y2: 25.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_2085",
    x1: 42.0103,
    y1: 22.9717,
    x2: 42.0103,
    y2: 25.1403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_2085",
    x1: 24.1921,
    y1: 27.5608,
    x2: 24.1921,
    y2: 47.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_2085",
    x1: 24.1244,
    y1: 0,
    x2: 24.1244,
    y2: 20.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_2085",
    x1: 17.0045,
    y1: 21.2202,
    x2: 17.0045,
    y2: 26.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_2085",
    x1: 24.2097,
    y1: 21.2202,
    x2: 24.2097,
    y2: 26.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_2085",
    x1: 31.4127,
    y1: 21.2202,
    x2: 31.4127,
    y2: 26.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon14.8afb8b3f6dbb3f1386ac2f3df3a72b41.svg";
export { ForwardRef as ReactComponent };